import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  header: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#075e54',
    marginBottom: '2px',
    textAlign: 'left',
  },
  content: {
    width: '100%',
  },
  footer: {
    fontSize: '11px',
    color: '#667781',
    marginTop: '4px',
    textAlign: 'right',
  },
}));

const MessageNodeBlock = ({ header, children, footer }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {header && (
        <Typography className={classes.header} component="span">
          {header}
        </Typography>
      )}
      <Box className={classes.content}>
        {children}
      </Box>
      {footer && (
        <Typography className={classes.footer} component="span">
          {footer}
        </Typography>
      )}
    </Box>
  );
};

export default MessageNodeBlock;
